import React, {useState, useEffect} from "react";
// react plugin for creating charts
import ChartistGraph from "react-chartist";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
// @material-ui/icons
import Store from "@material-ui/icons/Store";
import Warning from "@material-ui/icons/Warning";
import DateRange from "@material-ui/icons/DateRange";
import LocalOffer from "@material-ui/icons/LocalOffer";
import Update from "@material-ui/icons/Update";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Accessibility from "@material-ui/icons/Accessibility";
import BugReport from "@material-ui/icons/BugReport";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
import { Chat, CloudOff, WhatsApp } from "@material-ui/icons";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Table from "components/Table/Table.js";
import Tasks from "components/Tasks/Tasks.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import Danger from "components/Typography/Danger.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import { getAllLockers } from "../../services/lockers/lockers";


import { bugs, website, server } from "variables/general.js";

import {
  dailySalesChart,
  emailsSubscriptionChart,
  completedTasksChart,
} from "variables/charts.js";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);



export default function Dashboard() {
  const classes = useStyles();
  const [dataLockers, setDataLockers] = useState([]);
  const [status, setStatus] = useState({});
  const [mode, setMode] = useState({});
  const [statusData, setStatusData] = useState();
  const [ocupationRate, setOcupationRate] = useState(0);
  const [whatsapp, setWhatsapp] = useState(0)
  const [appData, setAppData] = useState();
  const [tipoData, setTipoData] = useState();

  useEffect(() => {
    getLockers();
  
    return () => {
    }
  }, [])

  useEffect(() => {
    
    copyTriggers(dataLockers)
  
    return () => {
    }
  }, [dataLockers])
  
  
  function copyTriggers(objeto) {

    let compo = [];
    var objectConstructor = ({}).constructor;
    var statusCount = {};
    var modeCount = {};
    var appVersionCount = {};
    var lockerTypeCount = {};
    let ocupationRateSum = 0;
    let ocupationRateCount = 0;
    var whatsappCount = 0;

    // console.log(JSON.stringify(objeto))
    const objetoFull = objeto;
    objeto = objeto.filter((el) => ((el?.mode === null) || (el?.mode === "active") || (el?.mode === "maintenance") || (el?.mode === ""))); 


    for (let obj in objeto) {
        const propriedade = objeto[obj];

          const pStatus = (propriedade.status == "active")?"active":"inactive";
          const cStatus = statusCount[`${pStatus}`];

          // const pMode = propriedade.mode?propriedade.mode:"active";
          // const cMode = modeCount[`${pMode}`];

          const pAppVersion = propriedade.app_version?propriedade.app_version:"Sem Versão";
          const cAppVersion = appVersionCount[`${pAppVersion}`];

          const pLockerType = (propriedade?.lockerType == "ecommerce")?"ecommerce":"condominio";
          const cLockerType = lockerTypeCount[`${pLockerType}`];
          
          statusCount[`${pStatus}`] = (cStatus >= 0)?(cStatus+1):1;
          // modeCount[`${pMode}`] = (cMode >= 0)?(cMode+1):0;
          appVersionCount[`${pAppVersion}`] = (cAppVersion >= 0)?(cAppVersion+1):1;
          lockerTypeCount[`${pLockerType}`] = (cLockerType >= 0)?(cLockerType+1):1;

          ocupationRateSum = ocupationRateSum + (propriedade?.ocupationRate*1);
          ++ocupationRateCount;

          if (propriedade?.whatsapp) {
            whatsappCount++;
          }

    }

    for (let obj2 in objetoFull) {
      const propriedade = objetoFull[obj2];
      const pMode = propriedade.mode?propriedade.mode:"active";
      const cMode = modeCount[`${pMode}`];
      modeCount[`${pMode}`] = (cMode >= 0)?(cMode+1):0;
  }

    setStatus(statusCount);
    setMode(modeCount);
    let mData = emailsSubscriptionChart.data;
    mData.series[0] = [modeCount?.maintenance || 0, modeCount?.active || 0, modeCount?.inactive || 0, modeCount?.installing || 0,];
    setStatusData(mData);
    setOcupationRate(ocupationRateSum/ocupationRateCount);
    setWhatsapp(whatsappCount)

    var appVersionData = {"labels":[],"series":[[]]}

    for (let ob in appVersionCount) {
      const opRes = appVersionCount[ob];
      appVersionData.labels.push(ob);
      appVersionData.series[0].push(opRes);
    }


    setAppData(appVersionData);


    var lockerTypeData = {"labels":[],"series":[[]]}

    for (let ob in lockerTypeCount) {
      const opRes = lockerTypeCount[ob];
      lockerTypeData.labels.push(ob);
      lockerTypeData.series[0].push(opRes);
    }

    setTipoData(lockerTypeData);

    console.log( JSON.stringify(appVersionData), appVersionCount, JSON.stringify(emailsSubscriptionChart.data))
    // console.log(JSON.stringify(statusCount), JSON.stringify(modeCount), mData, emailsSubscriptionChart.data)

    return compo;

}

  function getLockers() {

    getAllLockers((data) => {
      setDataLockers(data);
    });
  }

  return (
    <div>
      <GridContainer>

      <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Cloud />
              </CardIcon>
              <p className={classes.cardCategory}>Lockers Online</p>
              <h3 className={classes.cardTitle}>{status?.active || 0}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                Acabou de Atualizar
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <CloudOff />
              </CardIcon>
              <p className={classes.cardCategory}>Lockers Offline</p>
              <h3 className={classes.cardTitle}>{status?.inactive || 0}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                Acabou de Atualizar
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Chat />
              </CardIcon>
              <p className={classes.cardCategory}>Lockers com WhatsApp</p>
              <h3 className={classes.cardTitle}>{whatsapp}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <DateRange />
                Acabou de Atualizar
              </div>
            </CardFooter>
          </Card>
        </GridItem>
        
        <GridItem xs={12} sm={6} md={6}>
          <Card>
            <CardHeader color="success" stats icon>
              <CardIcon color="success">
                <Store />
              </CardIcon>
              <p className={classes.cardCategory}>Taxa de Ocupação Média</p>
              <h3 className={classes.cardTitle}>{`${ocupationRate.toFixed(2)} %`}</h3>
            </CardHeader>
            <CardFooter stats>
              <div className={classes.stats}>
                <Update />
                Acabou de Atualizar
              </div>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>

      <GridContainer>
        {/* <GridItem xs={12} sm={12} md={6}>
          <Card chart>
            <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={dailySalesChart.data}
                type="Line"
                options={dailySalesChart.options}
                listener={dailySalesChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Daily Sales</h4>
              <p className={classes.cardCategory}>
                <span className={classes.successText}>
                  <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                </span>{" "}
                increase in today sales.
              </p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> updated 4 minutes ago
              </div>
            </CardFooter>
          </Card>
        </GridItem> */}

        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={statusData || emailsSubscriptionChart.data} //{emailsSubscriptionChart.data}
                type="Bar"
                options={{
                  ...emailsSubscriptionChart.options,
                  high: ((statusData?.series[0])?Math.max(...statusData.series[0]):0), //
                }}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Status dos Lockers</h4>
              <p className={classes.cardCategory}>Quantidade de Lockers em cada Status</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> Acabou de Atualizar
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={appData || emailsSubscriptionChart.data} //{emailsSubscriptionChart.data}
                type="Bar"
                options={{
                  ...emailsSubscriptionChart.options,
                  high: ((appData?.series[0])?Math.max(...appData.series[0]):0), //
                }}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Versão do Núcleo</h4>
              <p className={classes.cardCategory}>Quantidade de Lockers em cada versão do núcleo</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> Acabou de Atualizar
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem xs={12} sm={12} md={12}>
          <Card chart>
            <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={tipoData || emailsSubscriptionChart.data} //{emailsSubscriptionChart.data}
                type="Bar"
                options={{
                  ...emailsSubscriptionChart.options,
                  high: ((tipoData?.series[0])?Math.max(...tipoData.series[0]):0), //
                }}
                responsiveOptions={emailsSubscriptionChart.responsiveOptions}
                listener={emailsSubscriptionChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Tipo dos Lockers</h4>
              <p className={classes.cardCategory}>Quantidade de Lockers de cada tipo</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> Acabou de Atualizar
              </div>
            </CardFooter>
          </Card>
        </GridItem>

        {/* <GridItem xs={12} sm={12} md={6}>
          <Card chart>
            <CardHeader color="success">
              <ChartistGraph
                className="ct-chart"
                data={completedTasksChart.data}
                type="Line"
                options={completedTasksChart.options}
                listener={completedTasksChart.animation}
              />
            </CardHeader>
            <CardBody>
              <h4 className={classes.cardTitle}>Completed Tasks</h4>
              <p className={classes.cardCategory}>Last Campaign Performance</p>
            </CardBody>
            <CardFooter chart>
              <div className={classes.stats}>
                <AccessTime /> campaign sent 2 days ago
              </div>
            </CardFooter>
          </Card>
        </GridItem> */}
      </GridContainer>

      {/* <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <CustomTabs
            title="Tasks:"
            headerColor="primary"
            tabs={[
              {
                tabName: "Bugs",
                tabIcon: BugReport,
                tabContent: (
                  <Tasks
                    checkedIndexes={[0, 3]}
                    tasksIndexes={[0, 1, 2, 3]}
                    tasks={bugs}
                  />
                ),
              },
              {
                tabName: "Website",
                tabIcon: Code,
                tabContent: (
                  <Tasks
                    checkedIndexes={[0]}
                    tasksIndexes={[0, 1]}
                    tasks={website}
                  />
                ),
              },
              {
                tabName: "Server",
                tabIcon: Cloud,
                tabContent: (
                  <Tasks
                    checkedIndexes={[1]}
                    tasksIndexes={[0, 1, 2]}
                    tasks={server}
                  />
                ),
              },
            ]}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Card>
            <CardHeader color="success">
              <h4 className={classes.cardTitleWhite}>Employees Stats</h4>
              <p className={classes.cardCategoryWhite}>
                New employees on 15th September, 2016
              </p>
            </CardHeader>
            <CardBody>
              <Table
                tableHeaderColor="success"
                tableHead={["ID", "Name", "Salary", "Country"]}
                tableData={[
                  ["1", "Dakota Rice", "$36,738", "Niger"],
                  ["2", "Minerva Hooper", "$23,789", "Curaçao"],
                  ["3", "Sage Rodriguez", "$56,142", "Netherlands"],
                  ["4", "Philip Chaney", "$38,735", "Korea, South"],
                ]}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer> */}
    </div>
  );
}
